export default __webpack_public_path__ + "static/media/heavenpic1.1008a11a.jpg";